import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ children, requiredRole, requiredRoles }) => {
  const { user, loading, switching, finishSwitch } = useAuth();

  const allowedRoles = requiredRoles || (requiredRole ? [requiredRole] : []);
  const userRole = user?.role;
  const roleAllowed = allowedRoles.length === 0 || (userRole && allowedRoles.includes(userRole));

  /**
   * `switching` covers the gap between an account swap landing in state and the page reloading
   * into the new capacity (AccountSwitcher does a full in-tab load). Without it the guard on the
   * route still being displayed sees a role that no longer belongs there and bounces to /login
   * before the reload happens.
   *
   * The effect is a safety net rather than the normal path: if a reload never happens, a route
   * that IS satisfied by the new role releases the flag so the app cannot sit on "Loading".
   */
  useEffect(() => {
    if (switching && user && roleAllowed) finishSwitch();
  }, [switching, user, roleAllowed, finishSwitch]);

  if (loading || switching) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!roleAllowed) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default PrivateRoute;
